// src/app/components/training/TrainingRoomsTableAgGrid.tsx
import React, { useMemo } from "react";
import { Box } from "@mantine/core";
import { AgGridReact } from "ag-grid-react";
import type { ColDef, GridOptions, SelectionChangedEvent } from "ag-grid-enterprise";

import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectHttpTdroomAll } from "./trainingdataSelectors";
import { setActiveTdRoomIdInRedux } from "./trainingSlice";

export const TrainingDataTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const rowData = useAppSelector(selectHttpTdroomAll);

  const columnDefs = useMemo<ColDef[]>(
    () => [
      { headerName: "Id", field: "_id", hide: true },
      {
        headerName: "Prosjektnr",
        field: "projectNo",
        sortable: true,
        filter: true,
        resizable: true,
        flex: 1,
        minWidth: 120,
      },
      {
        headerName: "Romnr",
        field: "roomNumber",
        sortable: true,
        filter: true,
        resizable: true,
        flex: 1,
        minWidth: 120,
      },
      {
        headerName: "Romnavn",
        field: "roomLongName",
        sortable: true,
        filter: true,
        resizable: true,
        flex: 2,
        minWidth: 220,
      },
    ],
    []
  );

  const gridOptions = useMemo<GridOptions>(
    () => ({
      animateRows: true,
      rowSelection: "single",
      suppressRowClickSelection: false,
      getRowId: (params) => String(params.data?._id ?? ""),
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      onSelectionChanged: (e: SelectionChangedEvent) => {
        const selected = e.api.getSelectedRows?.()?.[0];
        const id = selected?._id ? String(selected._id) : null;
        dispatch(setActiveTdRoomIdInRedux(id));
      },
    }),
    [dispatch]
  );

  return (
    <Box h="100%" className="ag-theme-alpine">
      <AgGridReact rowData={rowData ?? []} columnDefs={columnDefs} gridOptions={gridOptions} />
    </Box>
  );
};
